import { Slide, toast, ToastOptions } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

type NotifyOptions = {
  position?: ToastOptions['position'];
  autoClose?: ToastOptions['autoClose'];
  hideProgressBar?: ToastOptions['hideProgressBar'];
  closeOnClick?: ToastOptions['closeOnClick'];
  pauseOnHover?: ToastOptions['pauseOnHover'];
  draggable?: ToastOptions['draggable'];
  progress?: ToastOptions['progress'];
  theme?: ToastOptions['theme'];
  transition?: ToastOptions['transition'];
  type?: 'default' | 'info' | 'success' | 'warning' | 'error';
};

const notify = (message: string, options: NotifyOptions = {}): void => {
  toast(message, {
    position: options.position || 'top-center',
    autoClose: options.autoClose || 1000,
    hideProgressBar: options.hideProgressBar ?? true,
    closeOnClick: options.closeOnClick ?? true,
    pauseOnHover: options.pauseOnHover ?? false,
    draggable: options.draggable ?? true,
    progress: options.progress ?? undefined,
    theme: options.theme || 'light',
    transition: options.transition || Slide,
    type: options.type || 'default',
  });
};

export { notify };
